var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "register-tips-dialog",
            title: _vm.$t(_vm.title),
            visible: _vm.dialogVisible,
            area: 480,
            top: "middle",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.type === 0
            ? _c("div", { staticClass: "dialog-content" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("email_code_tips")))]),
                _c("div", [
                  _c("div", [_vm._v(_vm._s(_vm.$t("email_code_tips_1")))]),
                  _vm.email
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            "(" + _vm.$t("email_code_tips_2") + _vm.email + ")"
                          )
                        ),
                      ])
                    : _vm._e(),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("fail_receive_email_reason_2"))),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "dialog-content" }, [
                !_vm.isAuthenticationCodeRequired
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.openRegisterCountryType === 1,
                              expression: "openRegisterCountryType === 1",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("auth_code_required_tip")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.openRegisterCountryType === 2,
                              expression: "openRegisterCountryType === 2",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("authentication_code_tip")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _c("div", [
                      !_vm.isSpecialTipCountry
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.$t("auth_code_required_tip"))),
                          ])
                        : _vm._e(),
                      _vm.isSpecialTipCountry
                        ? _c("div", [
                            _c(
                              "p",
                              { attrs: { title: _vm.$t("us_auth_code_tips") } },
                              [_vm._v(_vm._s(_vm.$t("us_auth_code_tips")))]
                            ),
                            _c("div", { staticClass: "us-auth-code-tips" }, [
                              _c(
                                "div",
                                {
                                  attrs: {
                                    title: _vm.$t("us_auth_code_tips_1"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("us_auth_code_tips_1")))]
                              ),
                              _c(
                                "div",
                                {
                                  attrs: {
                                    title: _vm.$t("us_auth_code_tips_2"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("us_auth_code_tips_2")))]
                              ),
                              _c(
                                "div",
                                {
                                  attrs: {
                                    title: _vm.$t("us_auth_code_tips_3"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("us_auth_code_tips_3")))]
                              ),
                              _c(
                                "div",
                                {
                                  attrs: {
                                    title: _vm.$t("us_auth_code_tips_4"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("us_auth_code_tips_4")))]
                              ),
                              _c(
                                "div",
                                {
                                  attrs: {
                                    title: _vm.$t("us_auth_code_tips_5"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("us_auth_code_tips_5")))]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }